document.addEventListener('change', event => { if (event.target.matches('[data-variant-select]')) { const form = event.target.closest('form'); const price = form.querySelector('[data-price]'); const option = event.target.options[event.target.selectedIndex]; if (price && option.dataset.price) { if (option.dataset.comparePrice) price.innerHTML = `<s class="product-page__price-was">${option.dataset.comparePrice}</s><span class="product-page__price-sale">${option.dataset.price}</span>`; else price.textContent = option.dataset.price; } } });
window.addEventListener('scroll', () => document.body.classList.toggle('is-scrolled', window.scrollY > 70), { passive: true });
document.addEventListener('click', event => {
  const imageTrigger = event.target.closest('[data-product-image-open]');
  if (imageTrigger) {
    const dialog = document.querySelector('[data-product-image-dialog]');
    const dialogImage = dialog && dialog.querySelector('[data-product-image-dialog-image]');
    if (dialog && dialogImage) {
      dialogImage.src = imageTrigger.dataset.imageSrc;
      dialogImage.alt = imageTrigger.dataset.imageAlt || '';
      dialog.showModal();
    }
    return;
  }

  const imageClose = event.target.closest('[data-product-image-close]');
  if (imageClose) {
    imageClose.closest('[data-product-image-dialog]')?.close();
    return;
  }

  if (event.target.matches('[data-product-image-dialog]')) {
    event.target.close();
    return;
  }

  const control = event.target.closest('[data-bts-direction]');
  if (!control) return;

  const carousel = control.closest('[data-bts-carousel]');
  const track = carousel && carousel.querySelector('[data-bts-track]');
  const slide = track && track.querySelector('.bts-gallery__slide');
  if (!track || !slide) return;

  const gap = Number.parseFloat(window.getComputedStyle(track).gap) || 0;
  track.scrollBy({ left: Number(control.dataset.btsDirection) * (slide.offsetWidth + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});

document.addEventListener('click', event => {
  const trigger = event.target.closest('.bts-photo-open');
  if (trigger) {
    const source = trigger.querySelector('img');
    const dialog = trigger.closest('.shopify-section').querySelector('.bts-photo-dialog');
    const image = dialog.querySelector('img');
    image.src = source.dataset.fullSrc || source.currentSrc || source.src;
    image.alt = source.alt;
    dialog.showModal();
  }
  const close = event.target.closest('.bts-photo-close');
  if (close) close.closest('dialog').close();
  if (event.target.matches('.bts-photo-dialog')) event.target.close();
});

document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('.newsletter-form') || !window.fetch) return;
  event.preventDefault();
  if (form.dataset.sending || form.querySelector('[data-newsletter-success]')) return;
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('.newsletter-status');
  const originalLabel = button.textContent;
  form.dataset.sending = 'true';
  form.setAttribute('aria-busy', 'true');
  button.disabled = true;
  button.textContent = 'Sending…';
  status.textContent = '';
  try {
    const response = await fetch(form.action, {method: 'POST', body: new FormData(form), credentials: 'same-origin'});
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const success = html.querySelector('.newsletter-form [data-newsletter-success]');
    if (response.ok && success) {
      button.textContent = success.textContent;
      button.dataset.newsletterSuccess = 'true';
      button.classList.add('newsletter-confirmed');
      status.textContent = success.textContent;
      status.classList.add('visually-hidden');
      return;
    }
    const destination = new URL(response.url);
    if (destination.origin === location.origin && destination.pathname === '/challenge') {
      status.textContent = 'Please complete Shopify’s verification to sign up. ';
      const link = document.createElement('a');
      link.href = destination.href;
      link.textContent = 'Continue verification';
      status.append(link);
    } else {
      status.textContent = html.querySelector('.newsletter-form .errors')?.textContent.trim() || 'We couldn’t confirm your signup. Please try again.';
    }
  } catch {
    status.textContent = 'We couldn’t confirm your signup. Please check your connection and try again.';
  } finally {
    delete form.dataset.sending;
    form.removeAttribute('aria-busy');
    if (!button.hasAttribute('data-newsletter-success')) {
      button.disabled = false;
      button.textContent = originalLabel;
    }
  }
});

function initPomMotion(root = document) {
  root.querySelectorAll('[data-bts-carousel]').forEach(carousel => {
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';
    const track = carousel.querySelector('[data-bts-track]');
    const status = carousel.querySelector('[data-gallery-position]');
    const slides = track.querySelectorAll('.bts-gallery__slide');
    const update = () => {
      if (!track.clientWidth || !slides[0].offsetWidth) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const index = Math.round(track.scrollLeft / (slides[0].offsetWidth + gap));
      status.textContent = `${Math.min(index + 1, slides.length)} / ${slides.length}`;
      carousel.querySelector('[data-bts-direction="-1"]').disabled = track.scrollLeft <= 2;
      carousel.querySelector('[data-bts-direction="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    if (!slides.length || !status) return;
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.remove('pom-motion-pending');
        entry.target.classList.add('pom-reveal');
        observer.unobserve(entry.target);
      }
    }), {threshold:.15});
    root.querySelectorAll('.pom-merch .display, .pom-merch__item, .music-copy, .bts-gallery__title, .newsletter .display').forEach(el => {
      if (el.dataset.pomMotion) return;
      el.dataset.pomMotion = 'true';
      el.classList.add('pom-motion-pending');
      observer.observe(el);
    });
  }
}
initPomMotion();
document.addEventListener('shopify:section:load', event => initPomMotion(event.target));
